module.exports = __webpack_public_path__ + "static/media/icon_battery-level.ffb03e40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_battery-level.svg
// module id = 89
// module chunks = 0